// Generated by scripts/generate-owl-billion-overlap-glyphs.ts.
// Binary masks are captured at the exact fixed-slot positions used by the integer decoder.
// The bundle and price captures are intentionally independent because their slot origins differ.
export const RAW_OWL_BILLION_OVERLAP_GLYPHS = [
    {
        variant: "cleartype-rgb",
        field: "bundle",
        shape: "12",
        digit: "1",
        slotIndexFromRight: 0,
        slotX: 21,
        mask: "\u0000\b\fϾϾ˂ɢ",
    },
    {
        variant: "cleartype-rgb",
        field: "price",
        shape: "12",
        digit: "2",
        slotIndexFromRight: 9,
        slotX: 4,
        mask: "ϾϾ˂ɢɶȼ\u0000",
    },
    {
        variant: "cleartype-rgb",
        field: "bundle",
        shape: "21",
        digit: "2",
        slotIndexFromRight: 0,
        slotX: 21,
        mask: "̌Ύ˂ɢɾȼϾ",
    },
    {
        variant: "cleartype-rgb",
        field: "price",
        shape: "21",
        digit: "1",
        slotIndexFromRight: 9,
        slotX: 4,
        mask: "ɢɾȼϾϾ\u0000\u0000",
    },
    {
        variant: "cleartype-rgb",
        field: "bundle",
        shape: "11",
        digit: "1",
        slotIndexFromRight: 0,
        slotX: 21,
        mask: "\u0000\b\fϾϾ\fϾ",
    },
    {
        variant: "cleartype-rgb",
        field: "price",
        shape: "11",
        digit: "1",
        slotIndexFromRight: 9,
        slotX: 4,
        mask: "ϾϾ\fϾϾ\u0000\u0000",
    },
    {
        variant: "cleartype-bgr",
        field: "bundle",
        shape: "12",
        digit: "1",
        slotIndexFromRight: 0,
        slotX: 21,
        mask: "\u0000\b\bȌϾϾ˂",
    },
    {
        variant: "cleartype-bgr",
        field: "price",
        shape: "12",
        digit: "2",
        slotIndexFromRight: 9,
        slotX: 4,
        mask: "ȌϾϾ˂ɢȾȜ",
    },
    {
        variant: "cleartype-bgr",
        field: "bundle",
        shape: "21",
        digit: "2",
        slotIndexFromRight: 0,
        slotX: 21,
        mask: "Ȁ̌Ά˂ɪȾȜ",
    },
    {
        variant: "cleartype-bgr",
        field: "price",
        shape: "21",
        digit: "1",
        slotIndexFromRight: 9,
        slotX: 4,
        mask: "˂ɪȾȜϾϾ\u0000",
    },
    {
        variant: "cleartype-bgr",
        field: "bundle",
        shape: "11",
        digit: "1",
        slotIndexFromRight: 0,
        slotX: 21,
        mask: "\u0000\b\b\fϾϾ\f",
    },
    {
        variant: "cleartype-bgr",
        field: "price",
        shape: "11",
        digit: "1",
        slotIndexFromRight: 9,
        slotX: 4,
        mask: "\fϾϾ\fϾϾ\u0000",
    },
];
//# sourceMappingURL=billion-overlap-glyphs.js.map